import { t } from 'i18next';

// Components
import MarkdownContainer from '../../atoms/MarkdownContainer/MarkdownContainer';
import DetailHeaderTable from '../DetailHeaderTable/DetailHeaderTable';
import EventThumbnail from '../EventThumbnail/EventThumbnail';

// Domain
import { getDetailHeaderFieldType } from '../../../domain/detailHeader/detailHeaderUseCase';

/**
 * DetailHeaderFieldRenderer component - Renders different types of detail header fields
 * @param {object} props - Component props
 * @param {ApiDetailHeaderField} props.field - The field to render
 * @returns {JSX.Element | null} Rendered field or null if field type is not supported
 */
function DetailHeaderFieldRenderer({ field }) {
  if (!field) {
    return null;
  }

  const { type, data } = getDetailHeaderFieldType(field);

  if (!type) {
    return <p>{t('detailHeaderField.null')}</p>;
  }

  switch (type) {
    case 'text':
      return (
        <MarkdownContainer content={data.value} />
      );

    case 'table':
      return (
        <DetailHeaderTable table={data.table} />
      );

    case 'boolean':
      // TODO: Implémenter boolean rendering
      return (
        <p>Not implemented</p>
      );

    case 'image':
      return (
        <EventThumbnail
          imageUrl={data.imageUrl}
          label="Ajouter média"
          onClick={() => {
            // TODO: Handle image click (add/modify media)
          }}
        />
      );

    default:
      return (
        <p>Not implemented</p>
      );
  }
}

export default DetailHeaderFieldRenderer;
